import { Checkbox, Radio } from "@komplett/design-system";
import React from "react";

import { InsuranceI } from "../../App.types";
import strings from "../../utils/strings";

import { INSURANCE_MODE } from "./Insurance.type";

interface InsuranceOptionPropsI {
	insuranceLine: InsuranceI;
	name: string;
	checked: boolean;
	isFlexInsurance: boolean;
	onSelect: (selection: {
		event: React.ChangeEvent<HTMLInputElement>;
		insurance: InsuranceI;
		mode: string;
	}) => void;
}

export const InsuranceOption = ({
	insuranceLine,
	name,
	checked,
	isFlexInsurance,
	onSelect,
}: InsuranceOptionPropsI) => {
	const priceId = `insurance-option-price-${insuranceLine.id}`;
	const Input = isFlexInsurance ? Checkbox : Radio;

	return (
		<div className="addtocart-insurance__input-wrapper">
			<Input
				id={insuranceLine.id}
				className="addtocart-input__label"
				checked={checked}
				data-testid={`insurance-option-input-${insuranceLine.id}`}
				aria-describedby={priceId}
				name={name}
				value={insuranceLine.description}
				// Re-selecting the current insurance removes it
				onChange={(event) =>
					onSelect({
						event,
						insurance: insuranceLine,
						mode: checked ? INSURANCE_MODE.REMOVE : INSURANCE_MODE.CHANGE,
					})
				}
				wrapperProps={{
					"data-testid": `insurance-option-label-${insuranceLine.id}`,
				}}
				label={
					<>
						<span className="addtocart-input__label--description">
							{isFlexInsurance
								? insuranceLine.subscriptionDescription
								: insuranceLine.description}
						</span>
						<span className="addtocart-input__label--price" id={priceId}>
							{isFlexInsurance ? (
								<>
									{insuranceLine.monthlyPriceNet}
									{strings["subscription.price.permonth"]}
								</>
							) : (
								insuranceLine.priceNet
							)}
						</span>
					</>
				}
			/>
		</div>
	);
};
